/**************************************************
 * Nombre:       Formulario_Video_Uno
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Divider, Grid, Typography} from "@mui/material";
import {DriveFileRenameOutline, TitleOutlined} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoVideo from "../../../Modulo_formularios/Componentes/IngresoVideo";
import IngresoSelectFalsoVerdadero from "../../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoCheckGrupoMulti from "../../../Modulo_formularios/Componentes/IngresoCheckGrupoMulti";
import {LISTADATOS} from "../../../Constantes";

const Formulario_Video_Uno = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <Divider sx={{width: '100%'}}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Blanco'} dato={'tituloUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Titulo Resaltado'}
                                  dato={'tituloResaltadoUno'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoVideo dato={'videoUno'}  {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Parrafo'} dato={'tituloParrafoUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Resaltado Titulo Rosado'}
                                  dato={'rosadoTituloParrafoUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Blanco'}
                                  dato={'blancoTituloParrafoUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Resaltado Titulo Celeste'}
                                  dato={'celesteTituloParrafoUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Parrafo'} dato={'parrafoUno'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Formulario al finalizar el video</Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero nombre={'Mostrar Formulario'} dato={'formularioSiUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Formulario'}
                                  dato={'tituloFormularioUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Resaltado Titulo Formulario'}
                                  dato={'rosadoTituloFormularioUno'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Parrafo Fomrulario'}
                                  dato={'parrafoFormularioUno'} {...props}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoCheckGrupoMulti nombre={'Datos Formulario'}
                                            dato={'datosUno'} {...props}
                                            opciones={LISTADATOS}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Video_Uno